import React from 'react';

import SideOverlay from 'components/SideOverlay';
import H1 from 'components/H1';
import AuditTrailTable from 'components/AuditTrailTable';

/**
 * Drawer component that wraps AuditTrailTable in a SideOverlay.
 *
 * @param {Object} props
 * @param {number|string} props.personId - The person ID
 * @param {function} props.onClose - Close handler
 * @param {number|string} [props.initialFieldId] - Optional person data key ID to pre-select in the field filter
 */
export default function AuditTrailDrawer({ personId, onClose, initialFieldId }) {
    return (
        <SideOverlay maxWidth="1200px" minWidth="800px" onClose={onClose}>
            <div className="flex flex-col h-full">
                <div className="px-8 py-4">
                    <H1 className="!mb-0">Audit Trail</H1>
                </div>
                <AuditTrailTable personId={personId} initialFieldId={initialFieldId} />
            </div>
        </SideOverlay>
    );
}
